// SubscriptionPresentation.jsx
import { Link } from 'react-router-dom';
import React from 'react';
import { Button, ButtonToolbar, ButtonGroup } from 'ui';
import ColorConstants from 'constants/ColorConstants';
import LoadingButton from 'projects/components/LoadingButton';
import DelveAccountBody from 'projects/components/DelveAccountBody';
import SubscriptionBorder from 'projects/components/SubscriptionBorder';
import SubscriptionRedirectComponent from 'projects/components/SubscriptionRedirectComponent';
import SplitContainer from './SplitContainer';
import SubscriptionLeftContent from './SubscriptionLeftContent';

const SubscriptionPresentation = ({
  error,
  success,
  planPrice,
  discount,
  yearly,
  annual_plan_amount,
  userEmail,
  loading,
  onSubscribe,
  onSignOut
}) => (
  <div>
    <style type="text/css">{`
      .ui-btn.btn-left, .ui-btn.btn-left:hover, .ui-btn.btn-left:focus, .ui-btn.btn-left:active {
          background-color: #ffffff;
          color: ${ColorConstants.ACTIVE_BUTTON_BLUE};
          border: 1px solid ${ColorConstants.ACTIVE_BUTTON_BLUE};
      }
      .ui-btn.btn-right, .ui-btn.btn-right:hover, .ui-btn.btn-right:focus, .ui-btn.btn-right:active {
          background-color: ${ColorConstants.ACTIVE_BUTTON_BLUE};
          color: #ffffff;
          border: 1px solid ${ColorConstants.ACTIVE_BUTTON_BLUE};
      }
    `}</style>

    <SplitContainer
        leftContent={<SubscriptionLeftContent />}
    >
        <DelveAccountBody
            error={error}
            success={success}
            onSignOut={onSignOut}
            currentStep={3}
        >
        <SubscriptionRedirectComponent />
        {planPrice && (
            <SubscriptionBorder>
                <div style={{ marginLeft: 105, marginTop: 15, width: 400 }}>
                {discount && (
                    <div
                    style={{
                        color: !yearly
                        ? ColorConstants.LIGHT_GREY
                        : ColorConstants.ACTIVE_BUTTON_BLUE,
                        marginLeft: '30px',
                        marginBottom: '5px',
                        fontSize: '0.8em',
                    }}
                    >
                    Save {discount}
                    </div>
                )}
                <div>
                    <ButtonToolbar>
                    <ButtonGroup>
                        <Link to="/subscribe?plan=yearly" style={{ cursor: 'pointer' }}
                          className={`ui-btn ui-btn--sm ${!yearly ? 'btn-left' : 'btn-right'}`}>
                            Billed Annually
                        </Link>
                        <Link to="/subscribe" style={{ cursor: 'pointer' }}
                          className={`ui-btn ui-btn--sm ${!yearly ? 'btn-right' : 'btn-left'}`}>
                            Billed Monthly
                        </Link>
                    </ButtonGroup>
                    </ButtonToolbar>
                </div>
                </div>

                <div
                    style={{
                        marginTop: 30,
                        marginBottom: 20,
                        height: 80,
                        textAlign: 'center',
                    }}
                >
                    <h2>${planPrice}</h2>
                    <p style={{ fontSize: '.9em' }}>per team member per month</p>
                    {annual_plan_amount && (
                        <p
                        style={{
                            fontSize: '.8em',
                            color: ColorConstants.LIGHT_GREY,
                        }}
                        >
                        <em>billed as ${annual_plan_amount} annually</em>
                        </p>
                    )}
                </div>

                {!!userEmail && (
                        <div style={{ barginTomp: 50 }}>
                            <LoadingButton
                            width={300}
                            centered
                            variant="blue"
                            loading={loading}
                            onClick={onSubscribe}
                            >
                                Start Your 14 Day Free Trial
                            </LoadingButton>
                        </div>
                )}

                <div style={{marginBottom: 30}}/>


                <div style={{ borderBottom: '1px solid lightGray' }} />

                <div style={{ margin: 30 }}>
                    <h4 style={{textAlign:'center'}}>Simple qualitative analysis to help you hit your deadlines</h4>
                    <ul style={{paddingLeft: 30, paddingTop: 10, listStyleType: 'disc'}}>
                        <li style={{ margin: 5 }}>Intuitive coding interface</li>
                        <li style={{ margin: 5 }}>Unlimited projects, transcripts & codes</li>
                        <li style={{ margin: 5 }}>Keep ownership of your data</li>
                        <li style={{ margin: 5 }}>Easily export your research</li>
                        <li style={{ margin: 5 }}>Chat customer support</li>
                    </ul>
                </div>
            </SubscriptionBorder>
        )}
        </DelveAccountBody>
    </SplitContainer>
  </div>
);

export default SubscriptionPresentation;